export default function PowerQualitySvg() {
    return (
        <svg
            className="absolute inset-0 w-full h-full pointer-events-none"
            viewBox="0 0 1400 900"
            preserveAspectRatio="none"
        >
            <g transform="translate(0,-100)">
                <defs>
                    <marker
                        id="arrow"
                        markerWidth="8"
                        markerHeight="8"
                        refX="8"
                        refY="4"
                        orient="auto"
                    >
                        <path d="M0,0 L8,4 L0,8 Z" fill="#222" />
                    </marker>
                </defs>

                {/* MAIN PHASE LINES */}

                <line
                    x1="120"
                    y1="150"
                    x2="1050"
                    y2="150"
                    stroke="#222"
                    strokeWidth="2"
                />

                <line
                    x1="210"
                    y1="340"
                    x2="920"
                    y2="340"
                    stroke="#222"
                    strokeWidth="2"
                />

                <line
                    x1="120"
                    y1="520"
                    x2="790"
                    y2="520"
                    stroke="#222"
                    strokeWidth="2"
                />

                {/* VOLTAGE CA */}

                <line
                    x1="120"
                    y1="520"
                    x2="120"
                    y2="150"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                {/* VOLTAGE BC */}

                <line
                    x1="210"
                    y1="170"
                    x2="210"
                    y2="340"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                {/* VOLTAGE AB */}

                <line
                    x1="210"
                    y1="340"
                    x2="210"
                    y2="520"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                {/* V-N SECTION */}

                <line
                    x1="790"
                    y1="520"
                    x2="790"
                    y2="720"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                <line
                    x1="920"
                    y1="340"
                    x2="920"
                    y2="720"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                <line
                    x1="1050"
                    y1="150"
                    x2="1050"
                    y2="720"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                    markerEnd="url(#arrow)"
                />

                {/* NEUTRAL BUS */}

                <line
                    x1="790"
                    y1="720"
                    x2="1050"
                    y2="720"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                />

                <line
                    x1="120"
                    y1="720"
                    x2="1120"
                    y2="720"
                    stroke="#222"
                    strokeWidth="2"
                    strokeDasharray="10 10"
                />
            </g>    
        </svg>
    );
}